const { userAgent, maxTouchPoints, platform, } = window.navigator;
export const isIPad = Boolean(userAgent.match(/ipad/i)) || Boolean(maxTouchPoints && maxTouchPoints > 2 && /MacIntel/.test(platform));
export const isIOS = Boolean(userAgent.match(/iphone|ipod|ipad/i));
export const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent); // both MacOS and iOS
export const isChrome = Boolean(userAgent.match(/chrome\//i));
export const isApple = isIOS || isIPad || (isSafari && !isChrome);
